import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateStoreMutation = createMutationHook(
  CreatorIntegrationsApiClient.createMailchimpStore,
  {
    mutationKey: ['createMailchimpStore'],
  },
)
